import {
  PartnerComparisonAdditionalInfoRow,
  PartnerComparisonAdditionalInfoTD,
  PartnerComparisonStyledTable,
  PartnerComparisonTableBody,
  PartnerComparisonTableInlineExpander,
} from './partner_comparison_table.styles'
import { Text } from '@amzn/storm-ui'
import React, { useState } from 'react'
import { PartnerDetails } from '../../../directory/components/partner_comparison/compared_partners_context'
import { clickPartnerComparisonDetailsMetricHandler } from '../../../../util/partner_comparison_metrics_helper'
import { directoryStrings } from '../../../directory/directory_i18n_mappings'
import { Locale } from '../../../../generated/graphql'
import { useTranslation } from 'react-i18next'
import { RecognitionImage } from '../../partner_comparison_details.styles'
import { getAwardLocaleDetails } from '../../../../util/partner_helper'

interface RecognitionComparisonTableProps {
  selectedPartners: PartnerDetails[]
  emptyColumnCount: number
}

export const RecognitionsComparisonTable: React.FunctionComponent<RecognitionComparisonTableProps> = (props: RecognitionComparisonTableProps): JSX.Element => {
  const { selectedPartners, emptyColumnCount } = props
  const [isExpanderOpen, setIsExpanderOpen] = useState(true)
  const { t } = useTranslation()
  const handleClickExpander = (): void => {
    clickPartnerComparisonDetailsMetricHandler('partnerComparison.page.recognitions.expander.click')
    setIsExpanderOpen(prev => !prev)
  }

  const emptyColumns: JSX.Element[] | React.ReactFragment =
    emptyColumnCount === 0 ? <></> : [...Array(emptyColumnCount)].map((_, i) => <PartnerComparisonAdditionalInfoTD key={i} />)

  const partnerRecognitions = (partnerToDisplay?: PartnerDetails): JSX.Element[] | undefined =>
    partnerToDisplay?.awards?.map((award, index) => {
      return <RecognitionImage key={`${index}-recognition`} alt={getAwardLocaleDetails(award, Locale.EnUs)?.name} src={award.imageDownloadLocation} />
    })

  const awardsTable = (
    <PartnerComparisonStyledTable>
      <PartnerComparisonTableBody>
        <PartnerComparisonAdditionalInfoRow>
          <PartnerComparisonAdditionalInfoTD>
            <Text>{t(directoryStrings.TABLE_AWARDS_AND_SPECS)}</Text>
          </PartnerComparisonAdditionalInfoTD>
          {selectedPartners.map((partner: PartnerDetails, index: number) => {
            return <PartnerComparisonAdditionalInfoTD key={index}>{partnerRecognitions(selectedPartners[index])}</PartnerComparisonAdditionalInfoTD>
          })}
          {emptyColumns}
        </PartnerComparisonAdditionalInfoRow>
      </PartnerComparisonTableBody>
    </PartnerComparisonStyledTable>
  )

  return (
    <PartnerComparisonTableInlineExpander
      label={
        <Text type={'h3'} textColor={'base'}>
          {t(directoryStrings.TABLE_RECOGNITIONS)}
        </Text>
      }
      isOpen={isExpanderOpen}
      handleClick={handleClickExpander}
    >
      {awardsTable}
    </PartnerComparisonTableInlineExpander>
  )
}
